(() => {
  const initContext = () => {
    if (window.__vorugContactContextInitialized) return;

    const path = window.location.pathname.replace(/\/+$/, '');
    const params = new URLSearchParams(window.location.search);
    const isSampleRequest = /\/pages\/contact$/.test(path) && params.get('request') === 'sample';
    const isAdviceRequest = /\/pages\/contact$/.test(path) && params.get('request') === 'advice';
    const isRoomRequest = /\/pages\/services$/.test(path) && params.get('source') === 'pdp';
    if (!isSampleRequest && !isAdviceRequest && !isRoomRequest) return;

    const title = params.get('title') || '';
    const size = params.get('size') || '';
    const price = params.get('price') || '';
    const productHandle = params.get('product') || '';
    const variantId = params.get('variant') || '';
    const returnUrl = params.get('return') || '';
    const form = document.querySelector('form.contact-form, form[action^="/contact"]');
    if (!form || !title || !size) return;
    if ((isSampleRequest || isAdviceRequest) && form.closest('[data-vorug-service="contact"]')) return;

    window.__vorugContactContextInitialized = true;
    const wrapper = form.closest('.contact-form__wrapper') || form.parentElement;
    const formMount = form.closest('form-state') || form;
    const context = document.createElement('div');
    context.className = 'vorug-sample-context';

    const label = document.createElement('p');
    label.className = 'vorug-sample-context__label';
    label.textContent = isRoomRequest ? 'Room review' : isAdviceRequest ? 'Product guidance' : 'Sample request';

    const detail = document.createElement('p');
    detail.className = 'vorug-sample-context__detail';
    detail.textContent = [title, size, price].filter(Boolean).join(' · ');
    context.append(label, detail);

    if (returnUrl) {
      const back = document.createElement('a');
      back.className = 'vorug-sample-context__back';
      back.href = returnUrl;
      back.textContent = 'Back to this rug';
      context.appendChild(back);
    }

    if (formMount.parentElement) formMount.parentElement.insertBefore(context, formMount);

    if (isSampleRequest) {
      const heading = document.querySelector('.rich-text h1, main h1');
      if (heading) heading.textContent = 'Request a rug sample';

      const intro = wrapper ? wrapper.querySelector('h2') : null;
      if (intro) intro.textContent = 'A closer look, before you decide.';
    }

    if (isAdviceRequest) {
      const heading = document.querySelector('.rich-text h1, main h1');
      if (heading) heading.textContent = 'Ask about this rug';

      const intro = wrapper ? wrapper.querySelector('h2') : null;
      if (intro) intro.textContent = 'A second opinion, before you decide.';
    }

    if (isRoomRequest) {
      const roomAnchor = wrapper || form;
      if (roomAnchor && !document.getElementById('room-advice')) roomAnchor.id = 'room-advice';
    }

    const message = form.querySelector('textarea[name="contact[Message]"], textarea[name="contact[body]"]');
    if (message && !message.value) {
      message.value = isRoomRequest
        ? `I am considering ${title} (${size}${price ? `, ${price}` : ''}) and would like advice on how it will work in my room.`
        : isAdviceRequest
          ? `I am considering ${title} (${size}${price ? `, ${price}` : ''}) and would like a second opinion before ordering.`
          : `I would like to request a sample of ${title} (${size}${price ? `, ${price}` : ''}).`;
    }

    const addHidden = (name, value) => {
      if (!value) return;
      const exists = Array.from(form.querySelectorAll('input[type="hidden"]')).some((input) => input.name === name);
      if (exists) return;
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    };

    addHidden('contact[Request type]', isRoomRequest ? 'Room advice request' : isAdviceRequest ? 'Product guidance request' : 'Rug sample request');
    addHidden('contact[Product]', title);
    addHidden('contact[Product handle]', productHandle);
    addHidden('contact[Variant]', `${size}${variantId ? ` (variant ${variantId})` : ''}`);
    addHidden('contact[Price]', price);
    addHidden('contact[Return URL]', returnUrl);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContext, { once: true });
  } else {
    initContext();
  }

  window.setTimeout(initContext, 150);
})();
